import React, { FC } from 'react';
import { Carousel } from './Carousel';
import { Typography } from '@mui/material';

import { COLORS } from '@/constants';
import { getTranslations } from 'next-intl/server';
import { Container, Head, Wrapper } from '@/features/pages/home';
import { IHousingObjectResponse } from '@/types';

type FeaturedProps = {
  data: IHousingObjectResponse[];
};

export const Featured: FC<FeaturedProps> = async ({ data }) => {
  const t = await getTranslations();

  return (
    <Wrapper>
      <Container>
        <Head>
          <Typography
            fontSize={{ xs: 26, sm: 26, md: 34 }}
            lineHeight={1}
            fontWeight={700}
            color={COLORS['blue']}
          >
            {t('featuredObjects.title')}
          </Typography>
          <Typography
            fontSize={{ xs: 14, sm: 16, md: 18 }}
            lineHeight={1.26}
            fontWeight={600}
            color={COLORS['beige-silver']}
          >
            {t('featuredObjects.desc')}
          </Typography>
        </Head>
        <Carousel data={data} />
      </Container>
    </Wrapper>
  );
};
